// extracted by mini-css-extract-plugin
module.exports = {"columnsRoot":"Columns_columnsRoot__QJHLi","columnsContainer":"Columns_columnsContainer__4ufyF"};